<template>
  <b-modal
    v-model="isBadRequestModal"
    centered
    no-close-on-backdrop
    no-close-on-esc
    hide-header-close
    style="max-width: 600px"
  >
    <template #modal-title>
      <p class="lead text-blue-500 mt-3 mb-1">
        {{ $t('form.formOfPayment.badRequestModal.title') }}
      </p>
    </template>
    <template #default>
      <b-row class="badge-min-height rounded-sm mx-0 mt-n3 badge-color-negative" align-v="stretch">
        <b-col cols="auto" class="first-col">
          <b-row align-v="stretch" class="h-100">
            <b-col align-self="center">
              <SvgIcon icon="WarningIcon" color="negative-300" center></SvgIcon>
            </b-col>
          </b-row>
        </b-col>
        <b-col align-self="center" class="px-4">
          <p class="mb-0 text-base text-blue-500 font-weight-bold">
            {{ $t('form.formOfPayment.badRequestModal.notification') }}
          </p>
        </b-col>
      </b-row>
      <p
        v-html="
          $t('form.formOfPayment.badRequestModal.content', {
            childEditionId: $route.params.childEditionId,
            date: date
          })
        "
        v-orphans
        class="mb-0 mt-4 text-blue-500"
      ></p>
    </template>
    <template #modal-footer>
      <b-button
        class="button-width font-weight-bold"
        variant="primary"
        @click="routerPushHome"
        block
        pill
      >
        {{ $t('childPage.modalChildrenChosen.button') }}
        <i class="angle-right-icon ml-2 bg-white" style="height: 0.75rem"></i>
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import moment from 'moment'
import SvgIcon from '@/components/widgets/SvgIcon.vue'

export default {
  name: 'ModalChildrenBadRequest',
  props: {
    isBadRequest: {
      type: Boolean,
      default: false
    },
    timestamp: {
      type: String,
      default: ''
    }
  },
  components: {
    SvgIcon
  },
  data() {
    return {
      FULL_DATE_WITH_TIME_HYPHEN: 'DD-MM-YYYY H:mm:ss',
      isBadRequestModal: false
    }
  },
  methods: {
    routerPushHome() {
      this.$router.push({ name: 'Home' })
    }
  },
  computed: {
    date() {
      return moment(this.timestamp).format(this.FULL_DATE_WITH_TIME_HYPHEN)
    }
  },
  watch: {
    isBadRequest: {
      handle: (isBadRequest) => {
        this.isBadRequestModal = isBadRequest
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.badge-min-height {
  min-height: 75px;

  .first-col {
    width: 75px;
  }
}
</style>
